const MIGRATION_FLAG = 'migrate_library_searchtype_to_simple_v1';

export function forceSimpleSearchOnce() {
	try {
		// ✅ Run only once per browser
		if (localStorage.getItem(MIGRATION_FLAG) === '1') return;

		const raw = localStorage.getItem('persist:root');
		if (!raw) {
			localStorage.setItem(MIGRATION_FLAG, '1');
			return;
		}

		const root = JSON.parse(raw);

		// redux-persist stores each slice as a JSON string
		if (!root.library) {
			localStorage.setItem(MIGRATION_FLAG, '1');
			return;
		}

		const library = JSON.parse(root.library);

		const isAdvanced =
			library?.searchType === 'advanced' ||
			library?.filters?.advancedSearchFetched === true;

		if (!isAdvanced) {
			localStorage.setItem(MIGRATION_FLAG, '1');
			return;
		}

		const patchedLibrary = {
			...library,
			searchType: 'simple',
			queryAdvancedFetched: '',
			filters: {
				...(library.filters || {}),
				advancedSearchFetched: false,
			},
		};

		root.library = JSON.stringify(patchedLibrary);
		localStorage.setItem('persist:root', JSON.stringify(root));

		// ✅ mark done
		localStorage.setItem(MIGRATION_FLAG, '1');
	} catch (e) {
		// If persist is corrupted, safest minimal fallback:
		try {
			localStorage.removeItem('persist:root');
			localStorage.setItem(MIGRATION_FLAG, '1');
		} catch {}
	}
}
